<template>

    <modal :show="showModal" @closeModal="close">

        <div class="meap">

            <img class="meap__img" src="/img/icons/cancel-grey.svg" @click="close">

            <h1 class="meap__title">{{ $t('login_google_pop_up_ap_title') }}</h1>

            <p class="meap__text mt__8">{{ $t('login_google_pop_up_ap_description') }}</p>

            <button class="btn btn-green btn-big meap__btn mt__24" @click="cta">{{ $t(`login_google_pop_up_ap_cta`) }}</button>

        </div>

    </modal>

</template>

<script>

import Tag from '@/modules/tag'

import Modal from '@/components/modal/Modal'

export default {

    name: 'modal-error-application-password',

    components: {Modal},

    data() {
        return {
            showModal: false
        }
    },

    methods: {

        open() {
            this.showModal = true
            Tag.pageViewAll(this, 'login_google_pop_up_ap')
        },

        cta() {
            Tag.clickAll(this, 'create_ap')
            this.close()
        },

        close() {
            this.showModal = false
            this.$emit('close')
        }
    }

}

</script>

<style lang="scss" scoped>

.meap {
    position: relative;
    padding: 80px 24px 24px;
    display: flex;
    flex-direction: column;
    max-width: 480px;

    &__img {
        width: 32px;
        object-fit: contain;
        position: absolute;
        top: 24px;
        right: 24px;
    }

    &__title {
        font-size: 24px;
        font-weight: 600;
        line-height: 1.17;
        text-align: start;
        color: $charcoal;
    }

    &__text {
        font-size: 17px;
        line-height: 1.41;
        text-align: start;
        color: $neutralsMoon;
    }

    &__btn {
        background-color: $forest;
    }
}

</style>
